import React from 'react';

import necrolog from '../images/necrolog.jpg';
import gregory from '../images/gregory.jpg';
import taras from '../images/taras.jpg';
import materials from '../images/materials.jpg';
import boscohistory from '../images/boscohistory.jpg';
import office from '../images/office.jpeg';
import CustomizedDialogs from 'components/dialog';

const Communication = () => {
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <div className="flex flex-col justify-between md:flex-row">
          <div className="text-justify hyphens-auto">
            <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Комунікація</h1>
            <div className="pt-3 pb-3">
              Соціальна комунікація наповнює світ і визначає форму людського співіснування. Тому покликання салезіянського вихователя, який працює у центрі пропозицій та євангелізації, викликає особливий інтерес. Комунікація — це унікальний вимір салезіянської харизми. Вона була важливою за часів отця Боско, є закликом для кожного вихователя й залишається незамінною у Церкві та сучасному світі. Отець Боско зробив свою невтомну діяльність у сфері суспільної комунікації фундаментальним елементом свого покликання — бути вихователем, провідником молоді та усіх людей.            </div>
            <div className="pt-3 pb-3">
              Сприяння комунікації також відбувається через служіння у різних сферах діяльності, спрямованих на створення комунікаційних процесів. Тут слід взяти до уваги «дорожню карту комунікації 2024». Важливо уникати зосередження лише на окремих видах діяльності. Деякі оперативні напрями роботи у цьому секторі мають бути присутніми у пасторальних і комунікаційних виховних планах:
            </div>
            <ul className="pl-6 list-disc">
              <li className="pt-1 pb-1">
                Формування навичок критичного та виховного використання засобів соціальної комунікації й нових технологій.
              </li>
              <li className="pt-1 pb-1">
                Залучення молоді до створення повідомлень і контенту, використовуючи всі доступні нам засоби.
              </li>
              <li className="pt-1 pb-1">
                Покращення соціальної комунікації як нового простору зустрічі та єдності молоді.
              </li>
              <li className="pt-1 pb-1">
                Підтримка й цінування усіх форм і проявів спілкування.



              </li>
            </ul>
            <div className="pt-3 pb-3">
              Наша якість як вихователів і проповідників вимагає, щоб ми були кваліфікованими комунікаторами. Спілкування сприяє харизматичному сопричастю та мобілізації місії.
            </div>
            <div className="pt-3 pb-3">
              Ми, Салезіяни Святого Івана Боско, передусім зацікавлені у міжособистісному спілкуванні між дорослими та молоддю, між мирянами і богопосвяченими особами, між тими, хто має багатий досвід, і тими, хто робить перші кроки в житті, між усіма, хто має дари й готовий ними ділитися.
            </div>
            <div className="pt-3 pb-3">
              Превентивна система покладає виховну ефективність передусім на безпосередні особисті зустрічі — зустрічі довіри, дружби, уважного та зацікавленого слухання.
            </div>
            <div className="pt-3 pb-3">
              Тому необхідно культивувати вміння керувати динамікою відносин: якість взаємодії може впливати на формування особистості як конструктивно, так і негативно. Установки та виховні стилі відображаються в емоційних станах, які часто визначають поведінку.
            </div>
            <div className="pt-3 pb-3">
              Ми перебуваємо на перехідному етапі, проходимо через період глибокої технологічної та культурної революції. Інформація й способи її використання стають цифровими. Все відбувається в інтернеті, і молоді покоління («цифрові тубільці», «кібердіти») мають високі можливості доступу до технологій і володіють розвиненими цифровими навичками.
            </div>
            <div className="pt-3 pb-3">
              Технології є інструментом звільнення та розширення можливостей для молоді, але водночас вони ставлять виховне питання: підхід до технологій є важливим кроком на шляху зростання та утвердження власної ідентичності.
            </div>
            <div className="pt-3 pb-3">
              ЗМІ впливають на становлення особистості молоді, формування базових цінностей, ставлення до Бога і людини. Вони спонукають нас замислитись над тим, що є естетичним і високоморальним у навчанні молоді, а також над їхнім впливом на виховання.
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Communication;
